import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime"

dayjs.extend(relativeTime)

import "./components/relative-timestamp"
import "./components/remote-list"